var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveanimals2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.2 0 0 11.2 0 25C0 38.8 11.2 50 25 50C38.8 50 50 38.8 50 25C50 11.2 38.8 0 25 0ZM5 25C5 13.95 13.95 5 25 5C29.625 5 33.875 6.575 37.25 9.225L9.225 37.25C6.575 33.875 5 29.625 5 25ZM25 45C20.375 45 16.125 43.425 12.75 40.775L40.775 12.75C43.425 16.125 45 20.375 45 25C45 36.05 36.05 45 25 45Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveanimals2);
export default __webpack_public_path__ + "static/media/liveanimals2.aae2da67b6c526c94a40b4c9fffadc86.svg";
export { ForwardRef as ReactComponent };